import { Component, Input } from '@angular/core';
import {formatDate} from '@angular/common';

import * as Objects from '@core/objects';

@Component({
    selector: 'project-details-forbidden-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.scss']
})
export class ProjectDetailsForbiddenHeaderFeaturesComponent { 
    private readonly DEFAULT_DUE_TEXT = "Set Due Date";
    private readonly DEFAULT_DUE_ICON = "calendar";

    @Input() project: Objects.BasicRequest = null;
    public interactiveAsignee: boolean = false; // prevent action in assignee component

    public due: any = {
        icon: this.DEFAULT_DUE_ICON, // not used
        text: this.DEFAULT_DUE_TEXT
    };

	constructor(){}

	ngOnInit(){ 

	}

    protected setDuedate() {
        let today: Date = new Date();
        today.setHours(0,0,0,0);

        if(this.project.due_date == null) {
            this.due = {
                icon: this.DEFAULT_DUE_ICON,
                text: this.DEFAULT_DUE_TEXT
            };

            return;
        } 
       
        let dueDate: Date = new Date(this.project.due_date);
        dueDate.setHours(0,0,0,0);
        let formattedDate = formatDate(dueDate,'dd MMM yyyy', 'en_US');
        this.due.text = formattedDate;

    }

}